import axiosInstance from '../../../../config/axiosInstance';
const IssuePriorityService = {
    async GetAllIssuePriority(redirectCallback) {
        try {
            const response = await axiosInstance.get(`/SuperAdmin/GetIssuePriorityDefault`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteIssuePriority(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/SuperAdmin/DeleteIssuePriorityDefault?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetDefaulIssuePriority(ID, redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SuperAdmin/SetDefaulIssuePriority?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
        
};

export default IssuePriorityService;